import { PublicKey } from "@solana/web3.js"

export default function shopAddress(address) {

let addressFinal = address ? address : 'CVNN5d5ELJRyATF3Q1cn1xZ81cgysyaoqskE4fqYfiyR'

return new PublicKey(addressFinal) 
}